/**
 * Realtime 场次状态订阅 Hook
 */
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { LiveSession } from '@/types';

export function useRealtimeSession(sessionId: string | null) {
  const [session, setSession] = useState<LiveSession | null>(null);

  useEffect(() => {
    if (!sessionId) return;

    // 订阅场次状态变化
    const channel = supabase
      .channel(`session-${sessionId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'bilibili_live_sessions',
          filter: `id=eq.${sessionId}`,
        },
        (payload) => {
          console.log('[Realtime] 场次状态更新:', payload.new);
          setSession(payload.new as LiveSession);
        }
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, [sessionId]);

  return session;
}

/**
 * Realtime 所有场次列表订阅 Hook
 */
export function useRealtimeSessions() {
  const [newSession, setNewSession] = useState<LiveSession | null>(null);
  const [updatedSession, setUpdatedSession] = useState<LiveSession | null>(null);

  useEffect(() => {
    // 订阅新场次创建
    const channel = supabase
      .channel('live-sessions-list')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'bilibili_live_sessions',
        },
        (payload) => {
          console.log('[Realtime] 新场次创建:', payload.new);
          setNewSession(payload.new as LiveSession);
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'bilibili_live_sessions',
        },
        (payload) => {
          console.log('[Realtime] 场次状态更新:', payload.new);
          setUpdatedSession(payload.new as LiveSession);
        }
      )
      .subscribe((status) => {
        console.log('[Realtime] 订阅状态:', status);
      });

    return () => {
      channel.unsubscribe();
    };
  }, []);

  return { newSession, updatedSession };
}

